import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { api, endpoints } from "../utils/axiosInstance";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";

const AboutSection = () => {
  const [topBlogs, setTopBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopBlogs = async () => {
      try {
        setLoading(true);
        const response = await api.get(`${endpoints.blogs.topViews}`);
        setTopBlogs(response.data || []);
      } catch (error) {
        console.error("Error fetching top blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopBlogs();
  }, []);

  const handleReadMore = () => {
    navigate("/blogs");
  };

  return (
    <AboutContainer>
      <AboutTopWrapper>
        <AboutContent>
          <AboutTag>VỀ CHÚNG TÔI</AboutTag>
          <AboutTitle>CÂU CHUYỆN ẨM THỰC</AboutTitle>
          <AboutDescription>
            Hành trình của chúng tôi được tạo nên từ sự tận tâm, sáng tạo và cam
            kết không ngừng mang đến những trải nghiệm ẩm thực tuyệt vời. Hãy
            cùng chúng tôi thưởng thức tinh hoa của từng món ăn và những câu
            chuyện thú vị đằng sau chúng.
          </AboutDescription>
          <ReadMoreButton onClick={handleReadMore}>XEM THÊM</ReadMoreButton>
        </AboutContent>

        {!loading && topBlogs.length > 0 && (
          <FeaturedBlogCard
            onClick={() => navigate(`/blogs/detail/${topBlogs[0].slug}`)}
          >
            <img
              src={topBlogs[0].coverImage || "/images/default-blog.jpg"}
              alt={topBlogs[0].title}
            />
            <FeaturedContent>
              <h3>{topBlogs[0].title}</h3>
              <p>{topBlogs[0].description}</p>
              <BlogMeta>
                <ViewCount>👁️ {topBlogs[0].views} lượt xem</ViewCount>
                <PublishDate>
                  {new Date(topBlogs[0].date).toLocaleDateString("vi-VN")}
                </PublishDate>
              </BlogMeta>
            </FeaturedContent>
          </FeaturedBlogCard>
        )}
      </AboutTopWrapper>

      <TopBlogsSection>
        <TopBlogsGrid>
          {loading ? (
            <LoadingContainer>
              <Spin size="large" />
            </LoadingContainer>
          ) : (
            topBlogs.slice(1, 4).map((blog) => (
              <BlogCard
                key={blog._id}
                onClick={() => navigate(`/blogs/detail/${blog.slug}`)}
              >
                <BlogImage>
                  <img
                    src={blog.coverImage || "/images/default-blog.jpg"}
                    alt={blog.title}
                  />
                </BlogImage>
                <BlogContent>
                  <BlogTitle>{blog.title}</BlogTitle>
                  <BlogMeta>
                    <ViewCount>👁️ {blog.views} lượt xem</ViewCount>
                    <PublishDate>
                      {new Date(blog.date).toLocaleDateString("vi-VN")}
                    </PublishDate>
                  </BlogMeta>
                  <BlogDescription>{blog.description}</BlogDescription>
                </BlogContent>
              </BlogCard>
            ))
          )}
        </TopBlogsGrid>
      </TopBlogsSection>
    </AboutContainer>
  );
};

const AboutContainer = styled.section`
  padding: 2rem;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const AboutTag = styled.div`
  display: inline-block;
  background: #ff4b4b;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const AboutContent = styled.div`
  max-width: 600px;
  margin-bottom: 2rem;
`;

const AboutTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
`;

const AboutDescription = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ReadMoreButton = styled.button`
  background: none;
  border: 2px solid #333;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #333;
    color: white;
  }
`;

const TopBlogsSection = styled.div`
  margin-top: 3rem;
`;

const TopBlogsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const BlogCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
  }
`;

const BlogImage = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const BlogContent = styled.div`
  padding: 1.5rem;
`;

const BlogTitle = styled.h4`
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const BlogMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #666;
`;

const ViewCount = styled.span`
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

const PublishDate = styled.span``;

const BlogDescription = styled.p`
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const LoadingContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

const AboutTopWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeaturedBlogCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

const FeaturedContent = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.4rem;
    font-weight: 700;
    color: #222;
    margin-bottom: 0.75rem;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  p {
    color: #555;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  ${BlogMeta} {
    font-size: 0.9rem;
    color: #888;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export default AboutSection;
